<template>
  <div class="export-page">
    <p v-html="message"></p>
  </div>
</template>

<script>
  const request = require('request-promise-native')

  export default {
    name: 'export-page',
    data () {
      return {
        host: 'archetype-parallax.firebaseapp.com',
        sourceGenerator: '7ozhci8h9h.execute-api.us-east-1.amazonaws.com/dev/source',
        sourceUploader: 'https://9i4ei212ta.execute-api.ap-southeast-2.amazonaws.com/default/deployParallax',
        message: 'Exporting...',
        html: ''
      }
    },
    mounted () {
      // Just render the page
      this.generateHTML()
    },
    methods: {
      async generateHTML() {
        try {
          let href = location.href.indexOf('localhost') > -1 ? location.href.replace(/localhost:\d+/, this.host) : location.href
          href = href.replace(/edit/, 'preview').replace('https', 'http')
          console.log(location.href, href)
          let sourceUrl = `https://${this.sourceGenerator}?url=${encodeURIComponent(href)}&_=${Date.now()}`
          let response = await request({ method: 'get', url: sourceUrl, gzip: true, json: true, timeout: 20000 })
          let html = response.result.value.replace(/\\"/g, '"').replace(/<a[^>]+class="reload-button">[^<]+<\/a>/, '').replace('/static/css/app', `https://${this.host}/static/css/app`).replace('/static/js/main', `https://${this.host}/static/js/main`)
          let post = await request({ method: 'post', url: this.sourceUploader+'?_='+Date.now(), gzip: true, body: JSON.stringify({ project_id: this.$route.params.id, html }),  timeout: 20000 })
          var data = JSON.parse(post)
          this.message += `<br><br>Done!<br><br><br><br>Published URL:<br><a href="${data.url}" target="_blank">${data.url}</a>`
          //let _this = this
          //setTimeout(function() { _this.fakeCallback(sourceUrl) }, 1200)
        } catch(e) {
          this.message += `<br><br>Error!<br><br>Try again?`
          console.log(e)
        }
      },
      fakeCallback(sourceUrl) {
        this.message += `<br><br>Done!<br><br>Published URL:<br><a href="#">${sourceUrl}</a>`
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// src/components/Export-Page.vue